import { useCallback, useState } from "react";
import { COLORS } from "../constants/app";
import { Prestador, Turno } from "../interfaces";
import { ordenarArrayObjetosByDate } from "../utils/funcionalidadesArrays";
import { useSession } from "./SessionContext";
import http from "./httpAdapter";

export const useAgenda = () => {
  const [turnos, setTurnos] = useState<Turno[]>([]);
  const [cargando, setCargando] = useState(false);
  const { hcUL, setSesionInvalida, mostrarNotificacion } = useSession();

  const traerTurnos = useCallback(
    async (prestador: Prestador, fechaDesde: string, fechaHasta: string) => {
      setCargando(true);
      try {
        const config = { headers: { Authorization: `Bearer ${hcUL?.token}` } };
        const response = await http().get(
          `Turnos/TurnosPrestadorFecha/?prestador=${prestador.prestadorCod}&desde=${fechaDesde}&hasta=${fechaHasta}`,
          config
        );

        const turnosOrdenados: any = ordenarArrayObjetosByDate(response, "hora");
        setTurnos(turnosOrdenados);
        return turnosOrdenados;
      } catch (e: any) {
        if (e.response?.status === 401) {
          setSesionInvalida(true);
        } else {
          mostrarNotificacion(true, `Error: ${e.message}`, COLORS.ERROR);
        }
        throw e;
      } finally {
        setCargando(false);
      }
    },
    [hcUL?.token, setSesionInvalida, mostrarNotificacion]
  );

  const cancelarTurno = useCallback(
    async (codigoTurno: number) => {
      const config = { headers: { Authorization: `Bearer ${hcUL?.token}` } };
      await http().put(`Turnos/Cancelar/${codigoTurno}`, {}, config);
      mostrarNotificacion(true, "Turno cancelado exitosamente", COLORS.SUCCESS);
    },
    [hcUL?.token, mostrarNotificacion]
  );

  return { turnos, setTurnos, cargando, traerTurnos, cancelarTurno };
};
